import React from "react"
import propTypes from "prop-types"

const Group = ({ children, className, style }) => {
  return (
    <div style={style} className={["form_group", className].join(" ")}>
      {children}
    </div>
  )
}

Group.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  className: propTypes.string,
  style: propTypes.shape({})
}

Group.defaultProps = {
  className: "",
  style: {}
}

export default Group
